import { createAction, props } from '@ngrx/store';
import {Consumer} from '@emm/core/models/consumer.model';

export enum ConsumersAction {
    LoadAll = '[Menu Base Effects] Load All Consumers',
    LoadAllSuccess = '[Menu API] Load All Consumers Success',
    LoadAllFailure = '[Menu API] Load All Consumers Failure',
    Select = '[Menu Filters] Select Consumer',
    Delete = '[Consumer Context Menu] Delete Consumer',
    DeleteSuccess = '[Menu API] Delete Consumer Success',
    DeleteFailure = '[Menu API] Delete Consumer Failure',
    ReloadConsumers = '[Menu Filters] Reload Consumers',
}

export const ConsumersActions = {
    loadAll: createAction(ConsumersAction.LoadAll),
    loadAllSuccess: createAction(ConsumersAction.LoadAllSuccess, props<{ consumers: Consumer[] }>()),
    loadAllFailure: createAction(ConsumersAction.LoadAllFailure, props<{ error: any }>()),
    select: createAction(ConsumersAction.Select, props<{ tag: string }>()),
    delete: createAction(ConsumersAction.Delete, props<{ tag: string }>()),
    deleteSuccess: createAction(ConsumersAction.DeleteSuccess),
    deleteFailure: createAction(ConsumersAction.DeleteFailure, props<{ error: any }>()),
    reloadConsumers: createAction(ConsumersAction.ReloadConsumers),
};

export const AsyncActions = {
    loadActions: [ConsumersActions.loadAll, ConsumersActions.delete],
    successActions: [ConsumersActions.loadAllSuccess, ConsumersActions.deleteSuccess],
    errorActions: [ConsumersActions.loadAllFailure, ConsumersActions.deleteFailure],
};
